import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 自动加载 modules 下所有模块
const modulesFiles = require.context('./modules', true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

const store = new Vuex.Store({
  modules,
  // 严格模式（开发开启，生产关闭）
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
